import React from 'react';
import ImageGallery from 'react-image-gallery';

export default class VideoGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showIndex: false,
      showBullets: true,
      infinite: true,
      showThumbnails: true,
      showFullscreenButton: true,
      showGalleryFullscreenButton: true,
      showPlayButton: false,
      showGalleryPlayButton: true,
      showNav: true,
      isRTL: false,
      slideDuration: 450,
      slideInterval: 2000,
      slideOnThumbnailOver: false,
      thumbnailPosition: 'bottom',
      showVideo: {},
      useWindowKeyDown: true,
    };

    this._renderVideo = this._renderVideo.bind(this);
    this.galleryItems = [];
    this.galleryItemsSource = null;
  }

  _onSlide(index) {
    this._resetVideo();
  }

  _handleInputChange(state, event) {
    if (event.target.value > 0) {
      this.setState({[state]: event.target.value});
    }
  }

  _handleCheckboxChange(state, event) {
    this.setState({[state]: event.target.checked});
  }

  _handleThumbnailPositionChange(event) {
    this.setState({thumbnailPosition: event.target.value});
  }

  _resetVideo() {
    const hasOpenVideo = Object.keys(this.state.showVideo).length > 0;
    const shouldShowPlayButton = this.state.showPlayButton && !this.state.showGalleryPlayButton;
    const shouldShowFullscreenButton =
      this.state.showFullscreenButton && !this.state.showGalleryFullscreenButton;

    if (!hasOpenVideo && !shouldShowPlayButton && !shouldShowFullscreenButton) {
      return;
    }

    this.setState({
      showVideo: {},
      showGalleryPlayButton: this.state.showPlayButton || this.state.showGalleryPlayButton,
      showGalleryFullscreenButton:
        this.state.showFullscreenButton || this.state.showGalleryFullscreenButton,
    });
  }

  _toggleShowVideo(url) {
    const { showVideo } = this.state;
    this.setState({
      showVideo: {
        ...showVideo,
        [url]: !showVideo[url],
      },
    });

    if (!showVideo[url]) {
      if (this.state.showPlayButton) {
        this.setState({showGalleryPlayButton: false});
      }

      if (this.state.showFullscreenButton) {
        this.setState({showGalleryFullscreenButton: false});
      }
    }
  }

  _renderVideo(item) {
    return (
      <div>
        {this.state.showVideo[item.embedUrl] ? (
          <div className="video-wrapper">
            <a className="close-video" onClick={this._toggleShowVideo.bind(this, item.embedUrl)}>
            </a>
            <iframe width="560" height="315" src={item.embedUrl} frameBorder="0" allowFullScreen>
            </iframe>
          </div>
        ) : (
          <a onClick={this._toggleShowVideo.bind(this, item.embedUrl)}>
            <div className="play-button"></div>
            <img className="image-gallery-image" src={item.original} />
            {item.description && (
              <span className="image-gallery-description" style={{ right: '0', left: 'initial' }}>
                {item.description}
              </span>
            )}
          </a>
        )}
      </div>
    );
  }

  getGalleryItems() {
    if (this.galleryItemsSource !== this.props.items) {
      this.galleryItemsSource = this.props.items;
      this.galleryItems = this.props.items.map((item) =>
        item.video
          ? {
              ...item,
              renderItem: this._renderVideo,
            }
          : item
      );
    }

    return this.galleryItems;
  }

  render() {
    const items = this.getGalleryItems();

    return (
      <div className="app">
        <ImageGallery
          ref={(i) => (this._imageGallery = i)}
          items={items}
          onSlide={this._onSlide.bind(this)}
          infinite={this.state.infinite}
          showBullets={this.state.showBullets}
          showFullscreenButton={
            this.state.showFullscreenButton && this.state.showGalleryFullscreenButton
          }
          showPlayButton={this.state.showPlayButton && this.state.showGalleryPlayButton}
          showThumbnails={this.state.showThumbnails}
          showIndex={this.state.showIndex}
          showNav={this.state.showNav}
          isRTL={this.state.isRTL}
          thumbnailPosition={this.state.thumbnailPosition}
          slideDuration={parseInt(this.state.slideDuration)}
          slideInterval={parseInt(this.state.slideInterval)}
          slideOnThumbnailOver={this.state.slideOnThumbnailOver}
          additionalClass="app-image-gallery"
          useWindowKeyDown={this.state.useWindowKeyDown}
        />
      </div>
    );
  }
}
